var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1665 1.66666V10.8333M50.3332 8.16666V4.33332C50.3332 3.3999 50.3332 2.93319 50.1516 2.57667C49.9918 2.26307 49.7368 2.0081 49.4232 1.84831C49.0667 1.66666 48.6 1.66666 47.6665 1.66666H38.7649C37.547 1.66666 36.938 1.66666 36.4462 1.88952C36.0127 2.08594 35.6443 2.40201 35.3842 2.80059C35.0892 3.25282 34.9966 3.85469 34.8114 5.05843L34.3755 7.89176C34.1313 9.47942 34.0091 10.2732 34.2447 10.8909C34.4515 11.4331 34.8404 11.8864 35.3448 12.1732C35.9195 12.5 36.7227 12.5 38.329 12.5H38.9999C39.4666 12.5 39.6999 12.5 39.8782 12.5908C40.035 12.6707 40.1625 12.7982 40.2424 12.955C40.3332 13.1333 40.3332 13.3666 40.3332 13.8333V16.2785C40.3332 17.4133 41.2532 18.3333 42.3881 18.3333C42.6588 18.3333 42.9041 18.1739 43.014 17.9266L45.8146 11.6251C45.942 11.3385 46.0057 11.1952 46.1064 11.0901C46.1954 10.9973 46.3047 10.9262 46.4257 10.8826C46.5626 10.8333 46.7194 10.8333 47.033 10.8333H47.6665C48.6 10.8333 49.0667 10.8333 49.4232 10.6517C49.7368 10.4919 49.9918 10.2369 50.1516 9.92331C50.3332 9.56679 50.3332 9.10008 50.3332 8.16666Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 18.3333V9.16666M1.66675 10.8333V16.6667C1.66675 17.5871 2.41294 18.3333 3.33341 18.3333H14.522C15.7559 18.3333 16.8053 17.433 16.9929 16.2135L17.8903 10.3801C18.1233 8.86574 16.9516 7.49999 15.4194 7.49999H12.5001C12.0398 7.49999 11.6667 7.12689 11.6667 6.66666V3.72152C11.6667 2.58665 10.7468 1.66666 9.61188 1.66666C9.3412 1.66666 9.0959 1.82607 8.98596 2.07343L6.05336 8.67177C5.91961 8.97271 5.62118 9.16666 5.29185 9.16666H3.33341C2.41294 9.16666 1.66675 9.91285 1.66675 10.8333Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.3c11c5ebca9703c45ab371a01edb2f43.svg";
export { ForwardRef as ReactComponent };